function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#eab504",
  d: "M583 42v53H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#ef9413",
  d: "M0 0v95l583-53v53z"
});

function SvgCharityWaterVert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 583 95"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1ODMgOTUiPgogIDxwb2x5Z29uIHBvaW50cz0iNTgzLDQyIDU4Myw5NSAwLDk1IiBmaWxsPSIjZWFiNTA0Ii8+CiAgPHBvbHlnb24gcG9pbnRzPSIwLDAgMCw5NSA1ODMsNDIgNTgzLDk1IiBvcGFjaXR5PSIuMyIgZmlsbD0iI2VmOTQxMyIvPgo8L3N2Zz4=";
export { SvgCharityWaterVert as ReactComponent };